import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import ardp_logo from '../assets/image.png'
import { Button } from '@mui/material';
import { Logout } from '@mui/icons-material';
import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

function ResponsiveAppBar() {
  const { userState, setUserState } = useAuth();

  return (
    <>
      <AppBar position="static" component="nav">
        <Toolbar>
          <img src={ardp_logo} style={{ height: "40px" }} alt="adrp2go Logo" />
          <Box sx={{ display: { xs: "none", sm: "block" }, marginLeft: 2 }}>
            <Link to="/">
              <Button sx={{ color: "#fff", marginInline: "8px" }}>HOME</Button>
            </Link>
            {userState?.role == "systemadmin" ?
            <Link to="/beats">
              <Button sx={{ color: "#fff", marginInline: "8px" }}>BEATS</Button>
            </Link> : null}
            {userState?.role == "admin" || userState?.role == "systemadmin" ?
            <Link to="/teams">
              <Button sx={{ color: "#fff", marginInline: "8px" }}>TEAMS</Button>
            </Link> : null}
          </Box>
          <Box sx={{ display: { xs: "none", sm: "block" }, marginLeft: "auto" }}>
            <Button sx={{ color: "#fff" }} startIcon={<Logout />} onClick={() => setUserState(null)}>
              ABMELDEN
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Outlet />
    </>
  );
}

export default ResponsiveAppBar;